import React, { FC, useRef } from "react";
import type { PlatformSolvingDeficienciesProps } from "@/types";
import { ContentManager } from "../content-manager";
import { Image } from "../image";
import SplitTextAnimation from "../split-text-animation";
import { useInView } from "@/hooks/reveal-in-view";

export const PlatformSolvingDeficiencies: FC<PlatformSolvingDeficienciesProps> = ({
  title,
  cards,
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });

  return (
    <section className="platformSolvingDeficiencies">
      <div ref={ref} className="wrapper">
        <SplitTextAnimation
          htmlElement={
            <h2 className="platformSolvingDeficiencies--title">{title}</h2>
          }
          isInView={isInView}
        />
      </div>
      <div className="wrapper wrapper_lg">
        <div className="platformSolvingDeficiencies--cards">
          {cards.map((card, index) => {
            return (
              <div
                key={index}
                className="platformSolvingDeficiencies--card"
                onMouseEnter={(event) => {
                  const target = event.currentTarget as HTMLElement;
                  target.classList.add("hover-animation-bounce");
                }}
                onAnimationEnd={(event) => {
                  const target = event.target as HTMLElement;
                  target.classList.remove("hover-animation-bounce");
                }}
              >
                {card.image?.file && (
                  <Image
                    className="platformSolvingDeficiencies--card-icon"
                    noInline
                    src={card.image as any}
                    alt={card.image.title}
                  />
                )}
                {card.title && (
                  <ContentManager
                    className="platformSolvingDeficiencies--card-title"
                    content={card.title}
                  />
                )}
                {card.description && (
                  <ContentManager
                    className="platformSolvingDeficiencies--card-description"
                    content={card.description}
                  />
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
